import { Injectable } from "@angular/core";
import {
  NotificationSubscription,
  PersistenceAction,
} from "projects/shared-lib/src/public-api";
import { LocalStorageUtil } from "./local-storage.util";

@Injectable({ providedIn: "root" })
export class NotificationSubsUtil {
  constructor(public localStorageUtil: LocalStorageUtil) {}

  toSave(
    endpoint: string,
    p256dh: string,
    auth: string,
    userTypeName: string,
    langId: number,
    
  ): NotificationSubscription {
    const params = this.localStorageUtil.getGuidelinesParams(userTypeName);
    const userData = this.localStorageUtil.getUserTypeByName(userTypeName, true);
    console.log("userData");
    console.log(userData);

    console.log({
      id: 0,
      endPoint: endpoint,
      institutionId: +params.institutionId,
      categoryName: params.category,
      p256DH: p256dh,
      auth: auth,
      modelAction: PersistenceAction.INSERT,
      languageId: langId,
      surverUserId: userData.user_id
    });
    return {
      id: 0,
      endPoint: endpoint,
      institutionId: (params.institutionId) ? +params.institutionId : null,
      categoryName: params.category,
      p256DH: p256dh,
      auth: auth,
      modelAction: PersistenceAction.INSERT,
      languageId: langId,
      surverUserId: (userData.user_id) ? parseInt(userData.user_id) : null 
    } as NotificationSubscription;
  }
}
